import { render, staticRenderFns } from "./UmbPortalRedirect.vue?vue&type=template&id=1a429e64&scoped=true"
import script from "./UmbPortalRedirect.vue?vue&type=script&lang=ts"
export * from "./UmbPortalRedirect.vue?vue&type=script&lang=ts"
import style0 from "./UmbPortalRedirect.vue?vue&type=style&index=0&id=1a429e64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a429e64",
  null
  
)

export default component.exports